import * as moduleColumn from "@/utils/column_mapping/ModuleColumnMapping";
import * as driverColumn from "@/utils/column_mapping/DriverColumnMapping";
import * as multiLengthColumn from "@/utils/column_mapping/MultiLengthColumnMapping";
import { REGION_NA } from "../service/Constants";
import CellRenderer from "./cellRenderers/CellRenderer";

function moduleColumnDefinition(region, includeRthCalculations) {
  let moduleColumnDefinition = [];
  switch (region) {
    case REGION_NA:
      return [
        moduleColumn.countHeader,
        moduleColumn.seriesHeader,
        moduleColumn.parallelHeader,
        moduleColumn.nameHeader,
        moduleColumn.fluxHeader,
        moduleColumn.efficacyHeader,
        moduleColumn.currentHeader,
        moduleColumn.voltageHeader,
        moduleColumn.powerHeader,
        moduleColumn.thermalPowerHeader,
        moduleColumn.rthHeatsinkToAmbientHeader,
        moduleColumn.tcHeader,
        moduleColumn.nc12Header,
        moduleColumn.dataSheetHeader,
        moduleColumn.familyHeader,
        moduleColumn.LESDiameterHeaderInch,
        moduleColumn.lengthHeaderInch,
        moduleColumn.widthHeaderInch,
        moduleColumn.heightHeaderInch,
      ];
    default:
      moduleColumnDefinition = [
        moduleColumn.countHeader,
        moduleColumn.seriesHeader,
        moduleColumn.parallelHeader,
        moduleColumn.nameHeader,
        moduleColumn.fluxHeader,
        moduleColumn.efficacyHeader,
        moduleColumn.currentHeader,
        moduleColumn.voltageHeader,
        moduleColumn.powerHeader,
        moduleColumn.thermalPowerHeader,
        moduleColumn.rthHeatsinkToAmbientHeader,
        moduleColumn.tcHeader,
        moduleColumn.nc12Header,
        moduleColumn.dataSheetHeader,
        moduleColumn.familyHeader,
        moduleColumn.LESDiameterHeader,
        moduleColumn.lengthHeader,
        moduleColumn.widthHeader,
        moduleColumn.heightHeader,
      ];
      return moduleColumnDefinition.filter((item) => {
        // Check for ACL specific columns
        if (item.field === "calculationResult.rthHeatsinkToAmbient") {
          return includeRthCalculations;
        }
        return true;
      });
  }
}

function moduleColumnVisibility(region, includeRthCalculations) {
  switch (region) {
    default:
      return [
        ...moduleColumnDefinition(region, includeRthCalculations).map(
          (item) => {
            return {
              headerName: item.headerName,
              showAsOption: item.field,
              name: item.field,
              value: !item.hide,
            };
          }
        ),
      ];
  }
}

function driverColumnDefinition(region) {
  switch (region) {
    case REGION_NA:
      return [
        driverColumn.marketingNameHeader,
        driverColumn.shortNameHeader,
        driverColumn.pOutMax,
        driverColumn.iOutMin,
        driverColumn.iOutMax,
        driverColumn.effAtOperatingPoint120,
        driverColumn.effAtOperatingPoint277,
        driverColumn.effAtOperatingPoint347,
        driverColumn.effAtOperatingPoint480,
        driverColumn.lengthHeaderInch,
        driverColumn.widthHeaderInch,
        driverColumn.heightHeaderInch,
        driverColumn.vOutMin,
        driverColumn.vOutMax,
        driverColumn.effAtFullLoadHeader,
        driverColumn.dimmingTypesHeader,
        driverColumn.minDimPercentageHeader,
        driverColumn.inputVoltagesHeader,
        driverColumn.setOutPutCurrent,
        driverColumn.class2Header,
        driverColumn.familyHeader,
        driverColumn.nc12Header,
        driverColumn.dataSheetHeader,
        driverColumn.featuresHeader,
        driverColumn.certificationsHeader,
        driverColumn.urlULHeader,
        driverColumn.url3DHeader,
      ];
    default:
      return [
        driverColumn.nameHeader,
        driverColumn.pOutMax,
        driverColumn.vOutMin,
        driverColumn.effAtOperatingPoint230,
        driverColumn.isolationHeader,
        driverColumn.lengthHeader,
        driverColumn.widthHeader,
        driverColumn.heightHeader,
        driverColumn.vOutMax,
        driverColumn.iOutMin,
        driverColumn.iOutMax,
        driverColumn.setOutPutCurrent,
        driverColumn.effAtFullLoadHeader,
        driverColumn.dimmingTypesHeader,
        driverColumn.mountingHeader,
        driverColumn.familyHeader,
        driverColumn.nc12Header,
        driverColumn.dataSheetHeader,
      ];
  }
}

function driverColumnVisibility(region) {
  switch (region) {
    default:
      return [
        ...driverColumnDefinition(region).map((item) => {
          return {
            headerName: item.headerName,
            showAsOption: item.field,
            name: item.field,
            value: !item.hide,
          };
        }),
      ];
  }
}

function multiLengthColumnDefinition(region) {
  switch (region) {
    case REGION_NA:
      return [
        multiLengthColumn.countHeader,
        multiLengthColumn.nameHeader,
        multiLengthColumn.nc12Header,
        multiLengthColumn.dataSheetHeader,
        multiLengthColumn.familyHeader,
        multiLengthColumn.lengthHeaderInch,
        multiLengthColumn.widthHeaderInch,
        multiLengthColumn.heightHeaderInch,
      ];
    default:
      return [
        multiLengthColumn.countHeader,
        multiLengthColumn.nameHeader,
        multiLengthColumn.nc12Header,
        multiLengthColumn.dataSheetHeader,
        multiLengthColumn.familyHeader,
        multiLengthColumn.fluxHeader,
        multiLengthColumn.lengthHeader,
        multiLengthColumn.widthHeader,
        multiLengthColumn.heightHeader,
      ];
  }
}

function multiLengthColumnVisibility(region) {
  switch (region) {
    default:
      return [
        ...multiLengthColumnDefinition(region).map((item) => {
          return {
            headerName: item.headerName,
            showAsOption: item.field,
            name: item.field,
            value: !item.hide,
          };
        }),
      ];
  }
}

function emergencyDriverColumnDefinition(region) {
  switch (region) {
    case REGION_NA:
      return [
        driverColumn.shortNameHeader,
        driverColumn.nc12Header,
        driverColumn.dataSheetHeader,
        driverColumn.pOutMax,
        driverColumn.iOutMax,
        driverColumn.iInMax,
        driverColumn.vOutMin,
        driverColumn.inputVoltagesHeader,
        driverColumn.vOutMax,
        driverColumn.lengthHeaderInch,
        driverColumn.widthHeaderInch,
        driverColumn.heightHeaderInch,
      ];
    default:
      return [
        driverColumn.nameHeader,
        driverColumn.nc12Header,
        driverColumn.dataSheetHeader,
        driverColumn.pOutMax,
        driverColumn.iOutMax,
        driverColumn.iInMax,
        driverColumn.vOutMin,
        driverColumn.inputVoltagesHeader,
        driverColumn.vOutMax,
        driverColumn.lengthHeader,
        driverColumn.widthHeader,
        driverColumn.heightHeader,
      ];
  }
}

function emergencyDriverColumnVisibility(region) {
  return [
    ...emergencyDriverColumnDefinition(region).map((item) => {
      return {
        headerName: item.headerName,
        showAsOption: item.field,
        name: item.field,
        value: !item.hide,
      };
    }),
  ];
}

export {
  moduleColumnDefinition,
  driverColumnDefinition,
  multiLengthColumnDefinition,
  moduleColumnVisibility,
  driverColumnVisibility,
  multiLengthColumnVisibility,
  emergencyDriverColumnDefinition,
  emergencyDriverColumnVisibility,
  CellRenderer,
};
